<div class="main">
    <!-- <div class="loader">
        <div class="load">
            <mat-spinner></mat-spinner>
        </div>
    </div> -->
    <div class="header">
        <div class="text">
            {{ 'EXPRESS_DETAILS.express_shipment' | translate}} #{{orderData.shipment}} | {{orderData.status}}
          </div>
          <div class="created_at">
            {{ 'EXPRESS_DETAILS.created_date' | translate}} : {{toShortDateTime(orderData.updated_at)}}
            <i class="material-icons" style="cursor: pointer;" (click)="closeModal()">clear</i>
          </div>

    </div>
    <div class="section">
        <div class="tab_section">
            <div class="shipment_tab">
                {{ 'EXPRESS_DETAILS.shipment_details' | translate}}
            </div>
            <!-- <div class="activity_tab">
                Activity Timeline
            </div> -->
        </div>
        <div class="client">
            <span>Client :</span>
            <span> {{orderData.client}}</span>
        </div>
        <div class="shipment_details">
            <div class="pickup_details">
                <mat-card *ngFor="let pick of orderData.pickup_locations;let i=index;">
                    <div class="pickup_drop" >
                        <div class="pickup_bubble">
                            <p>P{{i+1}}</p>
                          
                          </div>
                        <div class="pickup">
                            <div><strong>{{(pick.loc_id && pick.loc_id.name) ? pick.loc_id.name : ''}}</strong> </div>
                            <div class="content">{{ (pick.loc_id && pick.loc_id.area) ? pick.loc_id.area : ''}}</div>
                            <!-- <div class="content"></div> -->
                            <div class="content"><strong>Scheduled Pickup Date and Time :  {{toShortDateTime(pick.date_time)}}</strong></div>
                        </div>
                    </div>
                  </mat-card>
                  <div class="drop_sec">
                    <mat-card *ngFor="let drop of orderData.delivery_locations;let i=index;">
                        <div class="pickup_drop">
                            <div class="drop_bubble">
                                <p>D{{i+1}}</p>
                              
                              </div>
                            <div class="pickup">
                                <div><strong>{{(drop.loc_id && drop.loc_id.name) ? drop.loc_id.name : ''}}</strong> </div>
                                <div class="content">{{ (drop.loc_id && drop.loc_id.area) ? drop.loc_id.area : ''}}</div>
                                <div class="content"><strong>Delivery Date and Time : {{toShortDateTime(drop.date_time)}}</strong></div>
                            </div>
                        </div>
                      </mat-card>
                  </div>
                  
            </div>
            <div class="border_line"></div>
            <div class="Driver_details" >
                <!-- <mat-card >
                    <div class="driver_header">
                        <div class="text">
                            <span>Driver, Vehicle Details</span>
                        </div>
                        <div class="menu_logo">
                            <img src="assets/logo.svg" alt="">
                        </div>
                    </div>
                    <div class="driver_personal_details">
                        <div class="driver_details_section">
                            <div class="driver_image">
                                <img src="assets/driver icon.svg" alt="">
                            </div>
                            <div class="driver_contact">
                                <div class="contact">Name</div>
                                <div class="contact"><strong>Rakesh Joshi</strong></div>
                                <div class="contact">Mob No</div>
                                <div class="contact"><strong>8889991245</strong></div>
                                <div class="contact">Vehicle No</div>
                                <div class="contact"><strong>KA13 GH 4321</strong></div>
                                <div class="contact">Vehicle Type</div>
                                <div class="contact"><strong>20' Canter</strong></div>
                            </div>
                        </div>
                    </div>
                  </mat-card> -->
                  <div class="Ewaybill_details">
                    <mat-card style="padding: 20px;" *ngFor="let inv of orderData.commercial_invoice_details;let i=index;">
                        <div class="eway_bill">
                            <span>Eway Bill :</span> 
                            <span> {{inv.ewaybill_no}}</span>
                        </div>
                      <div class="ewaybill_expiry">
                        <span>Eway Bill Expire Date :</span> 
                        <span> {{toShortDateTime(inv.e_waybill_expiry_date)}}</span>
                      </div>
                      </mat-card>
                </div>
            </div>
            
        </div>
        
    </div>
</div>